/* Slow the moving posts without jumping or restarting the loop. */
(() => {
  if (customElements.get('sam-social-marquee')) return;

  class SamSocialMarquee extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const viewport = this.closest('.sam-social__window');
      if (!viewport) return;
      this.hovered = false;
      viewport.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.updateSpeed();
      }, { signal });
      viewport.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.updateSpeed();
      }, { signal });
      this.addEventListener('focusin', () => this.updateSpeed(true), { signal });
      this.addEventListener('focusout', (event) => {
        this.updateSpeed(this.contains(event.relatedTarget));
      }, { signal });
    }

    updateSpeed(focused = this.contains(document.activeElement)) {
      const speed = this.hovered || focused ? 0.25 : 1;
      this.getAnimations().forEach((animation) => animation.updatePlaybackRate(speed));
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  }

  customElements.define('sam-social-marquee', SamSocialMarquee);
})();
